<template>
    <div v-if="isshow">
        <div style="height: 5px; background: #f2f2f2;"></div>
        <div style="margin-top: 5px;">
            <van-tabs  v-model="active" :line-width="0"  @change="change">
                <!-- <van-tab>
                    <div class="title" slot="title">
                        <div class="text">
                            第一个标签2
                            <div class="infos" v-if="relaCnt && relaCnt.campaignCnt>0">{{ relaCnt.campaignCnt }}</div>
                        </div>
                    </div>
                    <div class="tool">
                        <img
                                :src="require('@/assets/img/newlyAdd.png')"
                                style="margin-right:  0.2rem;"
                                class="newlyAddImg"
                                alt
                                @click="tagEdit=true"
                                srcset
                                >
                    </div>
                    <div class="tabsub">
                        <div class="tabNav">
                            <div class="navItem navItem--active">二级标签</div>
                        </div>
                        <div class="tabcontent">
                            <div class="conItem">
                                <van-tag plain>标签</van-tag>
                                <van-tag plain type="danger">标签</van-tag>
                                <van-tag plain type="primary">标签</van-tag>
                                <van-tag plain type="success">标签</van-tag>
                            </div>
                            <div class="conItem">
                                <van-tag round>标签</van-tag>
                                <van-tag round type="danger">标签</van-tag>
                                <van-tag round type="primary">标签</van-tag>
                                <van-tag round type="success">标签</van-tag>
                            </div>
                            <div class="conItem">
                                <van-tag mark>标签</van-tag>
                                <van-tag mark type="danger">标签</van-tag>
                                <van-tag mark type="primary">标签</van-tag>
                                <van-tag mark type="success">标签</van-tag>
                            </div>
                            <div class="conItem">
                                <van-tag>标签</van-tag>
                                <van-tag size="medium">标签</van-tag>
                                <van-tag size="large">标签</van-tag>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab>
                    <div class="title" slot="title">
                        <div class="text">
                            第二个标签
                            <div class="infos" v-if="relaCnt && relaCnt.courseCnt>0"> {{  relaCnt.courseCnt }}</div>
                        </div>
                    </div>
                    <div class="tabsub">
                        <empty></empty>
                    </div>
                </van-tab> -->
                <van-tab v-for="(item,index) in data" :key="index">
                    <div class="title" slot="title">
                        <div class="text">
                            {{item.labelName}}
                            <!-- <div class="infos" v-if="relaCnt && relaCnt.courseCnt>0"> {{  relaCnt.courseCnt }}</div> -->
                        </div>
                    </div>
                    <div>
                        <div class="tool">
                            <img
                                    :src="require('@/assets/img/newlyAdd.png')"
                                    style="margin-right:  0.2rem;"
                                    class="newlyAddImg"
                                    alt
                                    @click="onTagEdit(item.id)"
                                    srcset
                                    v-if="hasTagSetCreated"
                                    >
                        </div>
                        <div v-if="item.children && item.children.length>0  && cnt(item.children)" class="content">
                            <van-collapse v-model="item.activeNames">
                                <template v-for="(childrenItem,childrenIndex) in item.children" >
                                    <van-collapse-item v-if="childrenItem.use==1"    :key="`child-${childrenItem.id}-${childrenIndex}`"    :title="childrenItem.labelName" :name="childrenItem.childrenIndex">
                                        <span v-for="(info,infoIndex) in  filterByType( childrenItem.children,2)" :key="`child1-${info.id}-${infoIndex}`">
                                            <van-tag v-if="info.use==1" :color="info.type==2?'red':'#000'" size="large">{{info.labelName}}</van-tag>
                                        </span>
                                      <br/>
                                        <span v-for="(info,infoIndex) in filterByType( childrenItem.children,1)" :key="`child1-${info.id}-${infoIndex}`"  >
                                            <van-tag v-if="info.use==1" :color="info.type==2?'red':'#000'" size="large">{{info.labelName}}</van-tag>
                                        </span>
                                    </van-collapse-item>
                                </template>
                            </van-collapse>



                        </div>


                      <div style="margin-top: 0.2rem">
                        <van-collapse v-model="tagNames" v-if="item.labelName=='消费行为'">
                          <van-collapse-item  title="消费信息" name="1">
                            <div class="basic-information-flex" >
                              <ul class="basic-information-lists">
                                <li>
                                  <div class="basic-information-lists-item">购买徕卡学院课程总次数</div>
                                  <div class="basic-information-lists-text">
                                    {{extData.total_course_purchases}}
                                  </div>
                                </li>

                                <li>
                                  <div class="basic-information-lists-item">产品类订单累计消费金额</div>
                                  <div class="basic-information-lists-text">
                                    {{
                                      extData.U_TotalSalesAmount!=null
                                        ? $numeral(extData.U_TotalSalesAmount).format("0,0.00")
                                        : ""
                                    }}
                                  </div>
                                </li>

                                <li>
                                  <div class="basic-information-lists-item">服务类订单累计消费金额</div>
                                  <div class="basic-information-lists-text">
                                    {{
                                      extData.U_TotalService_orderAmout!=null
                                        ? $numeral(extData.U_TotalService_orderAmout).format("0,0.00")
                                        : ""
                                    }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </van-collapse-item>
                          <van-collapse-item  title="拥有产品" name="2">
                            <div class="basic-information-flex" >
                              <ul class="basic-information-lists">
                                <li>
                                  <div class="basic-information-lists-item">购买相机系列</div>
                                  <div class="basic-information-lists-text">
                                    {{ extData.U_OwnerCamera }}
                                  </div>
                                </li>

                                <li>
                                  <div class="basic-information-lists-item">购买镜头系列</div>
                                  <div class="basic-information-lists-text">
                                    {{ extData.U_OwnerLens }}
                                  </div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">注册相机系列</div>
                                  <div class="basic-information-lists-text">
                                    {{ extData.U_RegCamera }}
                                  </div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">注册镜头系列</div>
                                  <div class="basic-information-lists-text">
                                    {{ extData.U_RegLens }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </van-collapse-item>

                          <van-collapse-item  title="购买产品" name="3">

                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买相机数量</div>
                                  <div class="basic-text">
                                    {{extData.U_TotalCamera}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买镜头数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_TotalLens }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买运动光学数量</div>
                                  <div class="basic-text">
                                    {{extData.U_TotalSportoptiks}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买配件数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_TotalAccessories }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买Q相机数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Camera_Q_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买Compact数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Camera_Compact_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买M相机数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Camera_M_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买M镜头数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Lens_M_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买SL相机数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Camera_SL_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买SL镜头数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Lens_SL_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买APS相机数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Camera_APS_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买APS镜头数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Lens_APS_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买M-Kit数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Kit_M_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买SL-Kit数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Kit_SL_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>
                            <van-row>
                              <van-col span="11">
                                <div class="line">
                                  <div class="basic-title">购买APS-Kit数量</div>
                                  <div class="basic-text">
                                    {{extData.U_Kit_APS_No}}
                                  </div>
                                </div>
                              </van-col>
                              <van-col offset="2" span="11">
                                <div class="line">
                                  <div class="basic-title">购买Compact-Kit数量</div>
                                  <div class="basic-text">
                                    {{ extData.U_Kit_Compact_No }}
                                  </div>
                                </div>
                              </van-col>
                            </van-row>


                          </van-collapse-item>
                        </van-collapse>
                      </div>

                    </div>
                </van-tab>

            </van-tabs>


        </div>


        <!-- 弹出层 新增编辑 -->
    <van-popup v-model="tagEdit">
      <div class="add-model">
        <div class="addClientTitle">
            选择客户标签
            <div class="tip">提示：单击选择，再次点击取消。</div>
        </div>
        <div class="popInfo">

            <van-collapse v-model="activeNames">
                <van-collapse-item :title="item.labelName" v-for="(item,index) in model" :key="index" :name="item.id">
                    <div class="tabsub">
                        <div v-if="item.children && item.children.length>0" class="tabNav">
                            <div v-for="(childrenItem,childrenIndex) in item.children" @click.stop="handTreeTab(item,childrenItem.id,childrenIndex)" :title="childrenItem.id" :key="childrenIndex"
                                :class="{'navItem--active':(item.active==childrenItem.id || !item.active && childrenIndex==0) }" class="navItem">
                                {{childrenItem.labelName}}
                            </div>
                        </div>
                        <div v-if="item.children && item.children.length>0" class="tabcontent">
                            <template v-for="(childrenItem,childrenIndex) in item.children" >
                                <div  v-if="item.active==childrenItem.id || !item.active && childrenIndex==0" :key="childrenItem.id" :title="childrenItem.labelName" class="conItem">
                                    <span v-for="(info,infoIndex) in childrenItem.children" :key="infoIndex">
                                        <van-tag v-if="info.type==2" :plain="info.use!==1" :color="info.use==1?'red':'#000'" @click="handTag(info)" size="large">{{info.labelName}}</van-tag>
                                    </span>
                                    <!-- <van-tag  plain color="#000" size="large">666</van-tag> -->
                                </div>
                            </template>
                        </div>
                    </div>

                </van-collapse-item>
            </van-collapse>
        </div>
        <!-- 确定 取消 -->
        <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                   <div class="button-flex-item" @click="tagEdit=false">取消</div>
              </div>
              <div  class="button-flex-color">
                    <div class="button-flex-item button-active"  @click="saveLabel()">确定</div>
              </div>
        </div>
      </div>
    </van-popup>
    </div>

</template>
<script>
function flattern(data) {
  return data.reduce((iter, val) => {
    //use =1 选中， type=2 自定义标签，level==3 最后一级
    if(val.use==1 && val.type==2 && val.level==3) iter.push(val.id);
    return val.children ? [...iter, ...flattern(val.children)] : iter;
  }, []);
}

export default {
    name: "tagSetUp",
    components: {
    },
    props: {
        custId: String, // 限制 name 的属性值为 string 类型
        relaCnt: Object,
        isshow:Boolean,
    },
    data() {
        return {
            active:0,
            data: [],
            hasTagSetCreated: false, // 标签设置新增权限
           extData:{
             "U_TotalSalesAmount": "",
             "U_TotalService_orderAmout": "",
             "U_OwnerCamera": "",
             "U_OwnerLens": "",
             "U_Category2_List": "",
             "U_TotalLens": "",
             "U_TotalSportoptiks": "",
             "U_TotalAccessories": "",
             "U_Camera_Q_No": "",
             "U_Camera_Compact_No": "",
             "U_Camera_M_No": "",
             "U_Lens_M_No": "",
             "U_Camera_SL_No": "",
             "U_Lens_SL_No": "",
             "U_Camera_APS_No": "",
             "U_Lens_APS_No": "",
             "U_Kit_M_No": "",
             "U_Kit_SL_No": "",
             "U_Kit_APS_No": "",
             "U_TotalCamera": "",
             "U_Kit_Compact_No": "",
             "total_course_purchases": ""
           },
            model: [],
            activeNames:[],
            tagNames:[
              "1",
              "2",
              "3"
            ],
            tagEdit:false
        };
    },

  methods: {
        change(a,b){
            // this.laodData(a)
        },
        laodData(){
            this.$api.findlabelBySales({custId:this.custId,salesId: this.$wxuserUtil.getUserId()}).then(res=>{
                this.data = res.data.map((item)=>{
                    // item.activeNames = [0];
                    item.activeNames = item.children.map((_, index) => index);
                    return item;
                })

            })
        },
      /**
       *  加载客户的系统信息，只在消费行为下面显示
       */
        loadExInfo(){
          this.$api.findExtLabelBySales({custId:this.custId,salesId: this.$wxuserUtil.getUserId()}).then(res=>{
            if (res.data != null){
              this.extData = res.data;
            }
          })
        },
        onTagEdit(id){
            if(!this.data) return
            this.model =  JSON.parse(JSON.stringify(this.data))
            this.activeNames = [id]
            this.tagEdit=true
        },
        handTreeTab(item,key,index){
            item.active = key
            this.$forceUpdate();
        },
        handTag(info){
            info.use = info.use==1?0:1;
        },
        saveLabel(){
            var label = flattern(this.model);
            this.$api.saveLabel({custId:this.custId,salesId: this.$wxuserUtil.getUserId(),label:JSON.stringify(label)}).then(res=>{
                this.laodData();
                this.tagEdit=false
            })
        },
        filterByType(list, type) {
          return list.filter(item => item.type === type && item.use === 1);
        }
    },
    watch:{
        // active:{
        //     handler(newVal,oldVal) {
        //         console.log('active',newVal)
        //         this.laodData(newVal)
        //     },
        //     immediate: false
        // },
        isshow:{
            handler(newVal,oldVal) {
                if(newVal===true){
                    this.laodData()
                  this.loadExInfo()
                }
            }
        }
    },
    computed: {
        cnt() {
            //计算二级是否显示
            return function(arr){
                return arr.some((item) => {
                    return item.use == 1;
                })
            }
        }
    },
    mounted() {
        // 检查标签设置权限
        this.hasTagSetCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.TagSetCreated);
    },
    created() {

    }
  };
  </script>

  <style lang="less" scoped>
     /deep/ .van-tabs{
        .van-tabs__nav{
            background: none;
        }
        .van-tab{
            padding: 0;
            background: #eeeeee;
            color: #323233;
            &.van-tab--active{
                background: #fff;
                color: #323233;
            }
        }
        .van-hairline--top-bottom::after{
            border-width:  0px;
            display: none;
        }
    }

     .basic-information-flex {
       .basic-information-lists {
         li {
           display: flex;
           //    justify-content: space-between;
           -ms-flex-item-align: center;
           align-items: center;
           min-height: 0.8rem;
           word-break: break-all;
           /* word-wrap: break-word; */
           -webkit-line-clamp: 2;
           white-space:normal;
           text-overflow: ellipsis;
           // line-height: 0.8rem;
         }
         .basic-information-lists-item {
           width: 4.5rem;
           color: #7e7e7e;
           font-size: 0.31rem;
         }
         .basic-information-lists-text {
           font-size: 0.31rem;
           color: #4d4d4d;
           width:4rem;
         }
       }
     }

     .line{
       display: flex;
       -ms-flex-item-align: center;
       align-items: center;
       min-height: 0.8rem;
       word-break: break-all;
       /* word-wrap: break-word; */
       -webkit-line-clamp: 2;
       white-space:normal;
       text-overflow: ellipsis;
         .basic-title{
           width: 8.9rem;
           color: #7e7e7e;
           font-size: 0.28rem;
         }
         .basic-text {
           align-content: center;
           text-align: center;
           font-size: 0.28rem;
           color: #4d4d4d;
           width:4rem;
         }

     }


    /deep/ .van-collapse-item{
        margin-bottom: 5px;
        .van-cell{
            background:#f9f9f9;
            &.van-collapse-item__title--expanded{
                margin-bottom: 0;
            }
        }
        .van-cell:not(:last-child)::after {
            // border-bottom: 1px solid #666;
            left: 0;
        }
        .van-collapse-item__content{
            // border: 5px solid #f9f9f9;
            border-top: none;
        }
    }
    /deep/ .van-tag{
        margin: 5px;
    }
    .text{
        position: relative;
        display: inline-block;
    }
    .infos{
        display: inline-block;
        min-width: 15px;
        height:15px;
        line-height: 15px;
        background: red;
        color: #fff;
        // position: absolute;
        // right: -100%;
        // top: 0rem;
        border-radius: 50%;
        text-align: center;
        font-size: 12px;
        padding: 5px;
    }
    .tabsub{
        padding: 0rem 0.2rem;
        display: flex;
        .tabNav{
            width: 35%;
            // position: absolute;
            // left: 0;
            // top: 0;
            // bottom: 0;
            min-width: 120px;
            overflow: scroll;
            background-color: #fafafa;
            border: 1px solid #cacaca;
            // border-radius:0.2rem 0 0 0.2rem;
            border-right: 0;
            .navItem{
                position: relative;
                line-height: 44px;
                padding: 0 9px 0 15px;
                color: #000;
                &.navItem--active {
                    font-weight: bold;
                    background-color: #fff;
                }
            }
            .navItem--active::after {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 3.6px;
                background-color: #f44;
                content: '';
            }
        }
        .tabcontent{
            padding: 10px;
            border: 1px solid #cacaca;
            border-left: 0;
            border-radius:0 0.2rem 0.2rem 0;
            flex: 1;
            // margin-left: 10px;
        }
    }
    .tool{
        // width: 100%;
        text-align: right;
        display: flex;
        // justify-content: center;
        justify-content: flex-end;
        padding: 15px;
    }
    .newlyAddImg {
        width: 0.5rem;
        height: 0.5rem;
    }
    .content {
        // padding: 0.3rem 0.5rem;
        margin:0 10px;
        position: relative;

        // &::after{
        //     position: absolute;
        //     bottom: 0;
        //     content:' ';
        //     width: 100%;
        //     height: 1px;
        //     background-color: red;
        //     transform: scaleY(0.5);
        // }
    }

    // 新增客户
    .add-model {
        width: 95vw;
        max-width: 800px;
        // min-height: 5.5rem;
        // max-height: 90vh;
        background: #fff;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        .addClientTitle {
        //   width: 100%;
          text-align: center;
          font-size: 0.4rem;
          color: #000;
          padding: 15px 10px;
          font-weight: 900;
          background: #fff;
          .tip{
            font-size: 12px;
            text-align: left;
            line-height: 20px;
            font-weight: normal;
            color: #E51C23;
            margin-top: 10px;
          }
        }
        .popInfo{
            min-height: 7rem;
            max-height: 70vh;
            overflow-y: scroll;
            padding: 10px;
        }
        // 确定取消
        .confirm-cancel{
          width:100%;
          height:50px;
          border-top: 1px solid  #B3B8C3;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: auto;
          .button-flex-color{
            width:50%;
            height:50px;
            text-align: center;
            .button-flex-item{
              width:100%;
              height:100%;
              text-align: center;
              line-height: 50px;
               font-size:16px;
            }
          }
          .flex-border-button{
            border-right: 1px  solid  #A4ABBA;
          }
          .button-active{
             background: #E51C23;
             color:#fff;
          }
        }
      }
      .van-popup {
        border-radius: 0.25rem;
      }
  </style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/tagSetUp.vue